import { IPanelGeneratedDrawingDto } from "../../../../../responses/panelGeneratedDrawingDto";
import { PanelTypeGenerationStatus } from "../../../../../responses/panelGeneratedModelDto";
import {
    FacadeElement,
    TypesManagerPanelType,
    ICategory,
    StandardPanel,
} from "../../../../../responses/typesManagerCategories";
import { FacadeElementType } from "../../../panels/facadeElementType";
import { CategoryType } from "../../../typesManager/constants/panelTypeEnums";

export type CategoryView = {
    readonly name: CategoryType;
    readonly panelTypes: PanelTypeView[];
};

export type PanelTypeView = {
    readonly id: string;
    readonly generatedModelId: string | null;
    readonly name: string;
    readonly panels: PanelView[];
    readonly status: PanelTypeGenerationStatus | null;
    readonly isSelected: boolean;
    readonly generatedDrawings?: IPanelGeneratedDrawingDto[] | null;
};

export type PanelView = {
    readonly id: string;
    readonly userUniqueId: number;
    readonly panelTypeId: string | null;
    readonly customPanelTypeId: string | null;
    readonly elementType?: FacadeElementType;
    readonly panelDbId?: number;
};

/**
 * Performs mapping from domain ICategory to plain objects to be rendered in the UI.
 * This is done for three reasons:
 * 1) domain objects maintain references, react needs new objects to trigger rendering
 * 2) avoiding possible memory leaks
 * 3) structuredClone doesn't understand properties and copies private fields
 */
export const mapToViewable = (category: ICategory): CategoryView => {
    return {
        name: category.name,
        panelTypes: category.panelTypes.map(x => mapPanelTypeToViewable(x)),
    };
};

const mapPanelTypeToViewable = (panelType: TypesManagerPanelType): PanelTypeView => {
    return {
        id: panelType.id,
        generatedModelId: panelType.generatedModel?.id ?? null,
        name: panelType.name,
        status: panelType.status,
        isSelected: panelType.isSelected,
        generatedDrawings: panelType.generatedDrawings,
        panels: panelType.panels.map(x => mapPanelToViewable(x)),
    };
};

const mapPanelToViewable = (panel: FacadeElement): PanelView => {
    return {
        id: panel.id,
        userUniqueId: panel.userUniqueId,
        panelTypeId: panel.customPanelTypeId ?? (panel as StandardPanel).panelTypeId,
        customPanelTypeId: panel.customPanelTypeId,
        elementType: panel.elementType,
        panelDbId: panel.panelDbId,
    };
};
